module.exports = __webpack_public_path__ + "static/Noon-Logo-PNG.5f37d5bc.png";